import { useParams } from "react-router-dom";
import WithAuth from "../components/hoc/with-auth";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx";
import AccountHistoryPage from "../components/pages/account-history-page";

const AccountHistory = () => {
  const { login } = useParams();

  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Account Deals History"
          pageDesc="History of deals of the account"
        >
          {typeof login === "string" ? (
            <AccountHistoryPage login={parseInt(login)} />
          ) : null}
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default AccountHistory;
